/**
 * Tarih yardımcıları — UTC vs yerel timezone karışıklığını engellemek için
 * tek bir kaynak. `Date.toISOString()` her zaman UTC döner; Brussels gibi
 * pozitif timezone'larda yerel gece yarısı UTC'de hâlâ önceki gündür ve
 * `slice(0, 10)` tarihi 1 gün geriye kaydırır.
 *
 * Bu modül sadece **yerel** YYYY-MM-DD üretir/parse eder; planning ve
 * dashboard'daki "hangi gün?" ataması böylece operatörün saatiyle aynı
 * günü gösterir.
 *
 * Not: ISO-week math'i için `pages/planning/utils.js`'teki UTC tabanlı
 * fonksiyonlar değiştirilmemeli — board layout'u bunlara dayanıyor.
 */

/** Verilen Date'i yerel tarih olarak `YYYY-MM-DD` döner. */
export function formatLocalISO(d) {
  if (!(d instanceof Date) || Number.isNaN(d.getTime())) return '';
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${dd}`;
}

/** Bugünün yerel tarihi `YYYY-MM-DD`. */
export function todayLocalISO() {
  return formatLocalISO(new Date());
}

/** `YYYY-MM-DD` → yerel midnight Date. Backend ISO-date string'lerini
 *  parse ederken kullanılır. `new Date('2026-05-04')` UTC midnight
 *  oluşturur ve Brussels'da `getDate()` 4 değil 5 döner — bu fonksiyon
 *  yerel midnight tutar. */
export function parseLocalISO(s) {
  if (!s || typeof s !== 'string') return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(s);
  if (!m) return null;
  return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]), 0, 0, 0, 0);
}

/** Date objelerini gün-bazlı kaydırır (mutate etmez). */
export function addDays(d, n) {
  const x = new Date(d);
  x.setDate(x.getDate() + n);
  return x;
}

/** `d`'yi içeren ISO-haftanın Pazartesi midnight'ı (yerel). */
export function mondayOf(d) {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  const day = x.getDay();                  // 0=Sun..6=Sat
  const diff = day === 0 ? -6 : 1 - day;   // Sun→-6, Mon→0, Tue→-1...
  x.setDate(x.getDate() + diff);
  return x;
}
